module.exports = __webpack_public_path__ + "media/images/icons/icon-tiktok-fffde336cc180a33184b7c1c4da967a7.svg";